<template>
  <div class="nav-tab">
    <button
      v-for="option in options"
      :key="option.id"
      :class="{ active: option.id === value }"
      @click="$emit('input', option.id)"
    >
      {{ option.name }}
    </button>
    <div class="gap"></div>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    options: Array
  }
};
</script>

<style lang="scss" scoped>
.nav-tab {
  display: flex;
  align-items: flex-end;
  width: 100%;

  button {
    border: none;
    background: none;
    padding: 12px 24px;
    border-bottom: 1px solid #393444;
    font-size: 14px;
    line-height: 150%;
    color: #393444;
    opacity: 0.4;

    &.active {
      opacity: 1;
      font-weight: bold;
      color: #9155ec;
      border-bottom: 2px solid #9155ec;
      padding-bottom: 11px;
    }
  }

  .gap {
    flex: 1 1 100%;
    border-bottom: 1px solid #393444;
    opacity: 0.4;
  }
}
</style>
